import { render, staticRenderFns } from "./BlockEditorTable.vue?vue&type=template&id=23bc3b9a&"
import script from "./BlockEditorTable.vue?vue&type=script&lang=ts&"
export * from "./BlockEditorTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports